// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__CcPJd","list":"styles_list__QSqxi","listItem":"styles_listItem__5jUZn","center":"styles_center__mq1GF","right":"styles_right__EmmOX"};